import React from 'react';
import Layout from '../components/Layout';
import EmailConfirmationForm from '../components/EmailConfirmationForm';

const EmailConfirmation = () => (
  <Layout
    title="Resend Confirmation Email"
    subtitle=""
  >
    <center>
      <EmailConfirmationForm />
    </center>
  </Layout>
);


export default EmailConfirmation;



// WEBPACK FOOTER //
// ./src/pages/EmailConfirmation.jsx